import { sendGetRequest } from "services/apiService";

interface IPlaceTicketOrder extends IGenericAPIResponse {
  isSuccess: boolean;
}

export const getTicketOrder = async (eventId: string) => {
  const resp = await sendGetRequest<IPlaceTicketOrder>(
    `/ticket-order/?eventId=${eventId}`,
  );

  if (!resp.isSuccess) {
    throw new Error(resp?.message);
  }

  return resp;
};
